import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Rutinas genéricas sin fundamento técnico.', 'PDFs sueltos sin estructura ni análisis.', 'Improvisar sin un criterio claro para justificar cada ejercicio.'];
  return <section className="py-10 bg-background-dark border-y border-card-border-dark relative overflow-hidden" data-id="element-202">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-203">
        <FadeIn data-id="element-204">
          <div className="text-center mb-10" data-id="element-205">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-600/10 text-red-600 mb-6" data-id="element-206">
              <AlertTriangleIcon className="w-8 h-8" data-id="element-207" />
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-6 text-white" data-id="element-208">
              Dejá de depender de la{' '}
              <span className="text-red-500" data-id="element-209">intuición</span>
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-210">
              Te preguntan{' '}
              <strong className="text-white font-semibold" data-id="element-211">
                "¿Por qué este ejercicio?"
              </strong>{' '}
              y no siempre tenés la{' '}
              <strong className="text-red-500 font-semibold" data-id="element-212">
                justificación técnica
              </strong>{' '}
              lista. No es que no sepas entrenar — es que sin una base
              estructurada, terminás{' '}
              <strong className="text-red-500 font-semibold" data-id="element-213">
                improvisando
              </strong>
              .{' '}
              <strong className="text-white font-semibold" data-id="element-214">
                Tus alumnos lo notan. Y eso frena tu crecimiento profesional.
              </strong>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-215">
          <div className="bg-card-dark border border-red-500/20 rounded-2xl p-6 md:p-8" data-id="element-216">
            <h3 className="text-xl font-bold mb-5 text-center text-red-500" data-id="element-217">
              Lo que ya intentaste y no funcionó
            </h3>
            <ul className="space-y-3" data-id="element-218">
              {failedAttempts.map((attempt, index) => <li key={index} className="flex items-center gap-4 p-3 rounded-xl bg-red-500/5 border border-red-500/10" data-id="element-219">
                  <XCircleIcon className="w-5 h-5 text-red-500 shrink-0" data-id="element-220" />
                  <span className="text-gray-300" data-id="element-221">{attempt}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}